/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Cargos_As_Of_TruncatedInputs */

const en_cargos_as_of_truncated = /** @type {(inputs: Cargos_As_Of_TruncatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing the most recent ${i?.count} of ${i?.total} movements.`)
};

const es_cargos_as_of_truncated = /** @type {(inputs: Cargos_As_Of_TruncatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrando los ${i?.count} movimientos más recientes de ${i?.total}.`)
};

/**
* | output |
* | --- |
* | "Showing the most recent {count} of {total} movements." |
*
* @param {Cargos_As_Of_TruncatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_truncated = /** @type {((inputs: Cargos_As_Of_TruncatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_TruncatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_truncated(inputs)
	return es_cargos_as_of_truncated(inputs)
});